<template lang="html">
<div id="buildings">
    <el-row class="headLine">
        <el-col :span="4" style="text-align:left;">
            <el-button @click="goInner" size="small" type="primary">新建</el-button>
        </el-col>
        <!-- 选择器 -->
        <el-col :span="20" style="text-align:right;">
            <el-cascader size="small" ref="cascaderColumn" :options="columnTree" :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'dtos' ,checkStrictly: true}" v-model="params.dto.columnId" @change="selectChange" clearable placeholder="栏目"></el-cascader>
            <!-- <el-select class="seLect" v-model="params.dto.columnId" clearable placeholder="栏目" size="small" @change="columnChange">
                <el-option v-for="item in  options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select> -->
            <el-select class="seLect" v-model="params.dto.property" clearable placeholder="属性" size="small" @change="propertyChange">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="status" placeholder="状态" clearable size="small" @change="statusChange">
                <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="searchText" placeholder="标题搜索" class="input" size="small">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
        </el-col>
        <!-- 新建 -->

    </el-row>
    <List ref="list" />
</div>
</template>

<script>
import List from './src/list';
import {
    getColumnTree
} from '@/api/jingshi';

export default {
    components: {
        List
    },
    data() {
        return {
            searchText: '',
            status: '',
            params: {
                dto: {
                    columnId: '', // 栏目ID
                    keyword: '', // 关键词
                    status: '', // 1草稿、2待审核、3上线、4退回
                    property: '', // 1推荐属性、2热门属性、3推荐属性
                    class_type: "ArticleListCondition",
                },
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            },
            // one
            columnTree: [],
            // two
            options2: [{
                    value: 1,
                    label: '推荐'
                },
                {
                    value: 2,
                    label: '热门'
                },
                {
                    value: 3,
                    label: '置顶'
                },
            ],
            // three
            options3: [{
                    value: 1,
                    label: '草稿'
                },
                {
                    value: 2,
                    label: '待审核'
                },
                {
                    value: 3,
                    label: '上线'
                },
                {
                    value: 4,
                    label: '退回'
                }
            ],
        }
    },
    methods: {
        handleTree(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i]['dtos'].length == 0) {
                    delete data[i].dtos;
                } else {
                    this.handleTree(data[i]['dtos']);
                }
            }
            return data;
        },
        getColumnTree() {
            var vues = this;
            getColumnTree().then(res => {
                vues.columnTree = vues.handleTree(res.cmsColumnLists);
            })
        },
        selectChange: function (e) {
            console.log(e,this.params.dto.columnId);
            
            // var checkLabels = this.$refs['cascaderColumn'].getCheckedNodes();
            var id="";
            if(e){
                id = e[e.length-1];
            }else{
                id='';
            }
            var param = {
                columnId: id,
            };
            this.$refs.list.search(param);
        },
     
        propertyChange(e) {
            var param = {
                property: e,
            };
            this.$refs.list.search(param);
        },
        statusChange(e) {
            var param = {
                status: e,
            };
            this.$refs.list.search(param);
        },
        search() {
            var param = {
                keyword: this.searchText,
            };
            this.$refs.list.search(param);
        },
        // 新建
        goInner() {
            this.$router.push('/cms/add_publish');
        },
    },
    created() {
        this.getColumnTree();
    }

}
</script>

<style lang="scss" scoped>
#buildings {
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 500px;

    .headLine {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fff;
    }

    .seLect {
        width: 110px;
    }
}

.input {
    width: 240px;
    border-radius: none;
}
</style>

<style lang="css">
#buildings .el-input__inner {
    border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?ad08543c